import { newServer } from '../../constants/constants';
import React, { useEffect, useState } from 'react';

interface PageViewerProps {
  pageId: string;
}

const PageViewer: React.FC<PageViewerProps> = ({ pageId }) => {
  const [src, setSrc] = useState(''); // Almacena la URL de la página
  const [error, setError] = useState(''); // Almacena el mensaje de error, si ocurre

  //useEffect para cargar la pagina al entrar a la ruta
  useEffect(() => {
    loadPage();
  }, []);
  // Función para cargar la página
  const loadPage = async () => {
    //ruta con params id

    const pageUrl = `${newServer}landing-page/get/page-1`; // URL para obtener la página desde el backend

    try {
      const response = await fetch(pageUrl);

      if (response.ok) {
        setSrc(pageUrl);
        console.log(src);

        setError(''); // Limpia cualquier error previo
      } else {
        throw new Error('Page not found');
      }
    } catch (error) {
      setError('Error: Page not found'); // Muestra un mensaje de error si no se encuentra la página
      setSrc(''); // Limpia el iframe si hay un error
    }
  };

  useEffect(() => {
    const handlePostMessage = (event: MessageEvent) => {
      if (event.data?.url) {
        window.location.href = event.data.url; // O utiliza el router de React para navegar.
      }
    };

    window.addEventListener('message', handlePostMessage);

    return () => {
      window.removeEventListener('message', handlePostMessage);
    };
  }, []);

  return (
    <div>
      {/* Mostrar mensaje de error si ocurre */}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      {/* Mostrar iframe si el src está definido */}
      {src && (
        <iframe
          src={src}
          title={`Page ${pageId}`}
          style={{ width: '100%', border: 'none', backgroundColor: 'white' }}
          className='h-screen'
        />
      )}
    </div>
  );
};

export default PageViewer;
